import React from 'react';
import 'twin.macro';
import { useStaticQuery, graphql } from 'gatsby';
import { MdLocationPin, MdEmail } from 'react-icons/md';
import { IoMdPhonePortrait } from 'react-icons/io';

const contactQuery = graphql`
  query contactQuery {
    sanityGlobals {
      phone
      email
      address
    }
  }
`;

const ContactInfo = () => {
  const { sanityGlobals: data } = useStaticQuery(contactQuery);

  const contactData = [
    {
      key: '1',
      title: data.email,
      href: `mailto:${data.email}`,
      icon: <MdEmail />,
    },
    {
      key: '2',
      title: data.phone,
      href: `tel:${data.phone}`,
      icon: <IoMdPhonePortrait />,
    },
    {
      key: '3',
      title: data.address,
      href: '#',
      icon: <MdLocationPin />,
    },
  ];

  return (
    <ul tw="list-none mb-10">
      {contactData.map((item) => (
        <li tw="mb-5" key={item.key}>
          <a
            tw="text-sm font-normal text-gray-light hover:text-gray-100 flex"
            href={item.href}
          >
            <span tw="mr-1 text-green-darker text-2xl">{item.icon}</span>
            <p tw="w-full">{item.title}</p>
          </a>
        </li>
      ))}
    </ul>
  );
};

export default ContactInfo;
